import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/static/img/human-frv-scheme.svg'


const _hoisted_1 = { class: "right-bar__head" }

import VitaInfoModal from '@/components/UI/VitaInfoModal.vue';
import { ref } from 'vue';
import { reachGoal } from '@/utils/metrika';



export default /*@__PURE__*/_defineComponent({
  __name: 'VitaRightBarHead',
  setup(__props) {

const infoModal = ref({
  title: 'Справка',
  open: false
})

const closeInfoModal = () => {
  infoModal.value.open = false
}

const openInfoModal = () => {
  infoModal.value.open = true
  reachGoal('timetable-help-click');
}

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", null, [
        _createTextVNode("ФРВ "),
        _createElementVNode("br"),
        _createTextVNode(" сотрудника")
      ], -1)),
      _createVNode(_component_vita_icon, {
        class: "right-bar-info",
        name: "info-circle-dark",
        onClick: openInfoModal,
        "data-qa": "right-bar-head-icon-info-open"
      })
    ]),
    _createVNode(VitaInfoModal, {
      open: infoModal.value.open,
      onToggleInfoModal: closeInfoModal,
      title: infoModal.value.title,
      "modal-icon": "info-circle"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "help-layout" }, [
          _createElementVNode("h1", null, "Фонд рабочего времени (ФРВ)"),
          _createElementVNode("div", { class: "help-layout-grid" }, [
            _createElementVNode("div", { class: "help-layout-column" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "ФРВ основного персонала"),
                _createElementVNode("p", null, "Количество часов, выделенное, запланированное и фактически отработанное основным персоналом аптеки за месяц.")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Выделенный ФРВ"),
                _createElementVNode("p", null, "Количество часов, установленное для отработки в учетном периоде.")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Фактический ФРВ"),
                _createElementVNode("p", null, "Количество часов, отработанное в учетном периоде на текущий момент.")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Запланированный ФРВ"),
                _createElementVNode("p", null, "Количество часов, запланированное по графику смен.")
              ])
            ]),
            _createElementVNode("div", { class: "help-layout-column" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "ФРВ РВ"),
                _createElementVNode("p", null, "Количество часов, запланированное и отработанное в праздничные дни.")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Фактический ФРВ РВ"),
                _createElementVNode("p", null, "Количество часов, отработанное в праздничные дни.")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Запланированный ФРВ РВ"),
                _createElementVNode("p", null, "Количество часов, запланированное по графику смен в праздничные дни.")
              ])
            ])
          ]),
          _createElementVNode("hr"),
          _createElementVNode("div", { class: "help-layout-grid bottom-grid" }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Обозначение цветов статуса ФРВ"),
                _createElementVNode("ul", { class: "indicators-list" }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("span", { class: "color-indicator green" }),
                    _createElementVNode("span", null, "Норма часов")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("span", { class: "color-indicator orange" }),
                    _createElementVNode("span", null, "Недобор часов")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("span", { class: "color-indicator red" }),
                    _createElementVNode("span", null, "Превышение часов")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "ФРВ сотрудника в графике"),
                _createElementVNode("img", {
                  width: "400",
                  height: "106",
                  src: _imports_0,
                  alt: "ФРВ сотрудника в графике"
                })
              ])
            ])
          ])
        ], -1)
      ]))]),
      _: 1
    }, 8, ["open", "title"])
  ], 64))
}
}

})